export default __webpack_public_path__ + "static/media/close.24c482da.svg";